import {
  Table as UiTable,
  TableBody as UiTableBody,
  TableCell as UiTableCell,
  TableRow as UiTableRow,
} from '@/components/ui/table'
import { cn } from '@/lib/utils'

import {
  tableBodyVariants,
  tableCellVariants,
  tableRowVariants,
  tableVariants,
  type TableCellVariants,
  type TableRowVariants,
  type TableVariants,
} from '../../configs/table.config'

import type { ComponentProps } from 'react'

export function Table({ className, variant, ...props }: ComponentProps<typeof UiTable> & TableVariants) {
  return <UiTable className={cn(tableVariants({ variant }), className)} {...props} />
}

export function TableBody({ className, ...props }: ComponentProps<typeof UiTableBody>) {
  return <UiTableBody className={cn(tableBodyVariants(), className)} {...props} />
}

export function TableRow({ className, variant, ...props }: ComponentProps<typeof UiTableRow> & TableRowVariants) {
  return <UiTableRow className={cn(tableRowVariants({ variant }), className)} {...props} />
}

export function TableCell({ className, size, ...props }: ComponentProps<typeof UiTableCell> & TableCellVariants) {
  return <UiTableCell className={cn(tableCellVariants({ size }), className)} {...props} />
}
